const space: { [key: string]: string } = {
  xxSmall: '0.1rem', // 1px
  xSmall: '0.2rem', // 2px
  small: '0.4rem', // 4px
  normal: '0.8rem', // 8px
  xNormal: '1.2rem', // 12px
  medium: '1.6rem', // 16px
  xMedium: '2.0rem', // 20px
  large: '2.4rem', // 24px
  xLarge: '3.2rem', // 32px
  xxLarge: '4.0rem', // 40px
  xxxLarge: '4.8rem', // 48px
  xxxxLarge: '8.0rem', // 80px
};

export default space;
